import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../general.service';
import { DataService } from '../data.service';
import {TranslateService} from '@ngx-translate/core';

declare var Hashes: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './login.component.scss'
  ]
})

export class LoginComponent implements OnInit {

  public logo = "";
  public errorText = "";
  public displayError = false;
  public Username = "";
  public Name = "";
  public Password = "";
  public loginDisabled = false;
  public languageSelected = "en";
  public showMockLogin = false;
  public showLogin = true;
  public showMockUsername = false;
  public showMockName = false;
  public mockExamId = 0;
  public showAssessorComplete = false;
  public showCandidateComplete = false;
  public fullName: string = "";
  public email: string = "";
  public showScreen: boolean = false;

  constructor(
    public generalSvc: GeneralService,
    public dataSvc: DataService,
    public translate: TranslateService
  ) {
    // Set default values;
    this.logo = "https://cnavt.org/img/svg/logo.svg";
    this.Username = "";
    this.Password = "";
    this.Name = "";

    this.onLoad();
  }

  ngOnInit() {
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);      
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
      exisitingLangauge = "en";
    }
    this.languageSelected = exisitingLangauge;  
    
    setTimeout(() => {
      var uNa = localStorage.getItem("tUsername");
      var uPa = localStorage.getItem("tPassword");
      if (uNa != null && uPa != null) {
        this.Username = uNa;
        this.Password = uPa;
        this.submitLogin();
      }
    }, 2000);
  }

  changeLangauge(language){
    localStorage.setItem("userslanguage", language.toString());
    this.translate.setDefaultLang(language.toString());
    this.translate.use(language.toString());
    this.languageSelected = language.toString();  
  }

  checkEnetsecure(){
    if(!this.dataSvc.enetsecureMobile && !this.dataSvc.enetsecureWeb){
      var mobileSecure = this.generalSvc.getUrlParam("enetsecuremobile");
      var localStorageExamMethod = localStorage.getItem("examMethod");
      if(mobileSecure == "1" || localStorageExamMethod == "enetsecuremobile"){
        this.dataSvc.enetsecureMobile = true;
        this.dataSvc.enetsecureWeb = false;
        localStorage.setItem("examMethod", "enetsecuremobile");
        document.getElementById("version").innerHTML += " - eNetSecure";
      }
      else{
        var webSecure = this.generalSvc.getUrlParam("enetsecureweb");
        if(webSecure == "1" || localStorageExamMethod == "enetsecureweb"){
          this.dataSvc.enetsecureMobile = false;
          this.dataSvc.enetsecureWeb = true;
          localStorage.setItem("examMethod", "enetsecureweb");
          document.getElementById("version").innerHTML += " - eNetSecure";
        }
        else{
          this.dataSvc.enetsecureMobile = false;
          this.dataSvc.enetsecureWeb = false;
          localStorage.setItem("examMethod", "web");
        }
      }
    }  
    console.log("securemobile = " + this.dataSvc.enetsecureMobile);  
    console.log("secureweb = " + this.dataSvc.enetsecureWeb);  
  }

  

  onLoad() {
    var errorParam = this.generalSvc.getUrlParam("err");

    if (errorParam === 0) {
      this.errorText = "You entered incorrect login details.";
      this.displayError = true;
    }
    else if (errorParam == 1) {
      this.errorText = "Please login to eNetAssess.";
      this.displayError = true;
    }
    else {
      this.displayError = false;
    }
    if(this.checkExmLogin() == false)
    {
      this.checkEnetsecure();
      this.displayLoginOptions();
    }

    setTimeout(() => {
      this.showScreen = true;
    }, 1000);
  }

  checkExmLogin(){
    var uname = this.generalSvc.getUrlParam("un");
    if(uname !== null && uname !== undefined && uname !== ""){
      this.Username = uname.toString();
      var pword = this.generalSvc.getUrlParam("pw");
      if(pword !== null && pword !== undefined && pword !== ""){
        this.Password = pword.toString();
        this.dataSvc.initLogin(this.Username, this.Password);
        this.showLogin = false;
        this.showMockLogin = false;
        return true;
      }
    }
    return false;
  }

  displayLoginOptions(){
    var mockParam = this.generalSvc.getUrlParam("mock");
    if(mockParam == 1){
      this.showLogin = false;
      this.showMockLogin = true;
      var mockIdParam = this.generalSvc.getUrlParam("mid") as number;
      if(mockIdParam !== null && mockIdParam !== undefined){
        this.mockExamId = mockIdParam;
        var mockUsernameParam = this.generalSvc.getUrlParam("mu");
        if(mockUsernameParam !== null && mockUsernameParam !== undefined && mockUsernameParam === "1"){
          this.showMockUsername = true;
        }
        else{
          this.showMockUsername = false;
        }
        var mockUsersNameParam = this.generalSvc.getUrlParam("mn");
        if(mockUsersNameParam !== null && mockUsersNameParam !== undefined && mockUsersNameParam === "1"){
          this.showMockName = true;
        }
        else{
          this.showMockName = false;
        }
      }
    }
    else{
      this.showMockLogin = false;
      this.checkAssessorLogin();
      this.checkAnonymousCandidateLogin();
    }
  }

  getMembership(pass, salt) {
      var SHA1 = new Hashes.SHA1().b64(pass);
      var SHA1ws = new Hashes.SHA1().b64_hmac(pass, salt);
      return SHA1ws;
  }

  checkLogin() {
    if (this.Username.indexOf("demo") > -1)
      this.Username = "demo";

    this.dataSvc.initLogin(this.Username, this.Password);
  }

  checkMockLogin() {
    if (this.Username === "")
      this.Username = "mockuser";

      if (this.Name === "")
        this.Name = "Mock User";
      this.Password = "12345"

    this.dataSvc.initMockLogin(this.Username, this.Password, this.mockExamId, this.Name );
  }

  checkAssessorLogin(){
    var assessorParam = this.generalSvc.getUrlParam("al");
    if(assessorParam == "1"){
        this.showLogin = false;
        this.showMockLogin = false;
        this.showAssessorComplete = true;
    }
      else{
      var assessorAuthenticated = this.generalSvc.getUrlParam("aauth");
      if(assessorAuthenticated !== undefined && assessorAuthenticated !== null && assessorAuthenticated !== ""){
        this.dataSvc.initAssessorLogin(assessorAuthenticated);
      }
    }
  }

  checkAnonymousCandidateLogin(){
    var acandidateParam = this.generalSvc.getUrlParam("cl");
    if(acandidateParam == "1"){
        this.showLogin = false;
        this.showMockLogin = false;
        this.showCandidateComplete = true;
    }
      else{
      var candidateAuthenticated = this.generalSvc.getUrlParam("cauth");
      if(candidateAuthenticated !== undefined && candidateAuthenticated !== null && candidateAuthenticated !== ""){
        this.dataSvc.initAnonymousCandidateLogin(candidateAuthenticated);
      }
    }
  }

  submitTrialLogin() {
    this.loginDisabled = true;
    this.dataSvc.submitTrialLogin(this.fullName, this.email);

    setTimeout(() => {
      this.loginDisabled = false;
    }, 2500);
  }

  processLogin(query) {
    var scQuery = query.replace(/\+/g, "###plus###");
  }

  submitLogin() {
    this.loginDisabled = true;
    this.checkLogin();

    setTimeout(() => {
      this.loginDisabled = false;
    }, 2500);
  }

  submitMockLogin() {
    this.loginDisabled = true;
    this.checkMockLogin();

    setTimeout(() => {
      this.loginDisabled = false;
    }, 2500);
  }
}